import { Outlet } from 'react-router-dom';
import { CommandRail } from './CommandRail';
import { CommandPalette } from './CommandPalette';
import { OfflineBanner } from './OfflineBanner';

/** Fixed crimson CommandRail + work-area outlet. The CartSidebar is rendered
 *  per-page (only Sell needs it persistently) so other pages get full width. */
export function AppShell() {
  return (
    <div className="flex h-screen w-screen overflow-hidden">
      <CommandRail />
      <div className="flex min-w-0 flex-1 flex-col">
        <OfflineBanner />
        <main className="min-h-0 flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
    </div>
  );
}
